export default __webpack_public_path__ + "static/media/banner.1cd08c01.jpg";